import { Datagrid } from "react-admin";
import { Theme, useMediaQuery } from "@mui/material";

const CustomDataGrid = ({
  children,
  bulkActionButtons = false,
  rowClick = "show",
  listBgColor = "#F6F4F1",
  guideId = undefined,
  ...rest
}: any) => {
  const isSmall = useMediaQuery<Theme>("(max-width:800px)");
  const isMedium = useMediaQuery<Theme>("(max-width:1280px)");

  const routesWithSmallSpaces = [
    "dashboardAppointment",
    "dashboardCustomer",
    "dashboardAppointment-order",
    "dashboardWalk-in-order",
    "dashboard"
  ];

  const isSmallSpaceRoute = routesWithSmallSpaces.includes(
    window.location.pathname?.split("/")?.join("")
  );

  return (
    <Datagrid
      bulkActionButtons={bulkActionButtons}
      rowClick={isSmall ? false : rowClick}
      hover={isSmall ? false : true}
      guide-id={guideId}
      sx={{
        backgroundColor: listBgColor,
        borderRadius: "0px",
        tr: {
          "@media screen and (max-width:800px)": {
            borderBottom: "solid 4px #F8D1C0"
          },
          td: {
            padding:
              isMedium && !isSmall && isSmallSpaceRoute ? "6px 8px" : "6px 12px"
          }
        },
        "tr::before": {
          "@media screen and (max-width:800px)": {
            content: '""',
            display: "block",
            height: "4px",
            width: "100%",
            backgroundColor: "#D9ECF1"
          }
        },
        "thead tr": {
          "@media screen and (max-width:800px)": {
            borderWidth: "0px"
          }
        },
        "thead tr::before": {
          "@media screen and (max-width:800px)": {
            content: '""',
            display: "block",
            height: "0px",
            width: "0px"
          }
        },
        "tr:last-child": {
          "@media screen and (max-width:800px)": {
            borderBottom: "solid 4px transparent"
          }
        },
        "tr:first-of-type::before": {
          "@media screen and (max-width:800px)": {
            content: '""',
            display: "block",
            height: "0px",
            width: "0px"
          }
        },
        ".RaDatagrid-headerCell": {
          backgroundColor: listBgColor,
          fontSize: "14px",
          lineHeight: "16px",
          "@media screen and (max-width:1280px)": {
            padding: isSmallSpaceRoute ? "6px 8px" : "6px 12px"
          },
          "@media screen and (max-width:800px)": {
            display: "none"
          }
        },
        ".RaDatagrid-rowCell": {
          "@media screen and (max-width:800px)": {
            display: "flex",
            flexDirection: "column",
            borderWidth: "0px"
          }
        },
        ".RaDatagrid-rowCell span": {
          fontSize: "14px",
          "@media screen and (max-width:800px)": {
            verticalAlign: "top"
          }
        },
        ".RaDatagrid-rowCell > span": {
          "@media screen and (max-width:800px)": {
            display: "flex",
            gap: "8px"
          }
        },
        ".RaDatagrid-rowCell:last-child > span": {
          "@media screen and (max-width:800px)": {
            gap: "0px"
          }
        },
        ".RaDatagrid-rowCell > span::before": {
          "@media screen and (max-width:800px)": {
            content: "attr(data-label)",
            display: "flex",
            minWidth: "30%",
            width: "30%",
            fontWeight: "600",
            textAlign: "left"
          }
        },
        ".RaDatagrid-rowCell:last-child > span::before": {
          "@media screen and (max-width:800px)": {
            content: '""',
            minWidth: "0px",
            width: "0px"
          }
        },
        ".RaDatagrid-rowCell:has(.locationCell)": {
          verticalAlign: "top"
        },
        ".RaDatagrid-rowCell:has(.checkInButtonCell)": {
          verticalAlign: "top",
          width: "92px"
        },
        ".RaDatagrid-rowCell:has(.threeDotsButtonCell)": {
          verticalAlign: "top",
          width: "28px"
        }
      }}
      {...rest}
    >
      {children}
    </Datagrid>
  );
};

export default CustomDataGrid;
